import { instance as axios } from "./baseUrl";


export const subscriptionHabitationApi = ({paymentType,  housingType, numberOfRooms, startDate, address, floorLevel, roommates, contractReference}) =>
  axios.post("subscription/habitation/session", { paymentType,  housingType, numberOfRooms, startDate, address, floorLevel, roommates, contractReference});

export const priceHabitationApi = (paymentType,  housingType, numberOfRooms) =>
  axios.post("subscription/habitation/price", { paymentType,  housingType, numberOfRooms });

export const initSignature = (contractReference) =>
  axios.post("subscription/habitation/contract/init-signature", { contractReference });

export const attestationContract = (contractReference) =>
  axios.post("subscription/habitation/contract/attestation", { contractReference });